import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet';
import { Badge } from '@/components/ui/badge';
import { Sparkles } from 'lucide-react';
import { changelogEntries } from './changelog';

const typeColors = {
  feature: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
  improvement: 'bg-green-500/10 text-green-600 dark:text-green-400',
  fix: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
  update: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
};

const typeLabels = {
  feature: 'Feature',
  improvement: 'Improvement',
  fix: 'Fix',
  update: 'Update',
};

interface ChangelogDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ChangelogDrawer: React.FC<ChangelogDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="w-full sm:max-w-lg">
        <SheetHeader>
          <div className="flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-primary" />
            <SheetTitle>Changelog</SheetTitle>
          </div>
          <SheetDescription>
            Latest updates and improvements to Folge Cloud
          </SheetDescription>
        </SheetHeader>

        <div className="mt-6 h-[calc(100vh-120px)] overflow-y-auto pr-4">
          <div className="space-y-6">
            {changelogEntries.map((entry, index) => (
              <div
                key={index}
                className="relative pl-6 pb-6 border-l-2 border-border last:border-l-0 last:pb-0"
              >
                <div className="absolute -left-[5px] top-0 h-3 w-3 rounded-full bg-primary border-2 border-background" />
                
                <div className="space-y-2">
                  <div className="flex items-center gap-2 flex-wrap">
                    <Badge
                      variant="outline"
                      className={typeColors[entry.type]}
                    >
                      {typeLabels[entry.type]}
                    </Badge>
                    <span className="text-xs text-muted-foreground">
                      {entry.date}
                    </span>
                    {entry.version && (
                      <Badge variant="secondary" className="text-xs">
                        {entry.version}
                      </Badge>
                    )}
                  </div>
                  
                  <h3 className="font-semibold text-foreground">
                    {entry.title}
                  </h3>
                  
                  {entry.description && (
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {entry.description}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
